import * as React from 'react';
import { FC } from 'react';
import { Button, IconButton, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';

interface BreadMoveForwardModalProps {
  open: boolean;
  onAdditionalOptions: () => void;
  onClose: () => void;
}

const BreadMoveForwardModal: FC<BreadMoveForwardModalProps> = ({
  open,
  onAdditionalOptions,
  onClose,
}) => {
  return (
    <Dialog maxWidth={false} sx={{ maxWidth: '750px', margin: 'auto', paddingTop: '40px' }} fullWidth open={open} onClose={onClose}>
      <DialogTitle 
        variant="h4" 
        sx={{ 
          color: '#243F8F', 
          fontWeight: 'bold',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingRight: '16px', 
        }}
      >
        Welcome Back
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: '#243F8F',
            '&:hover': {
              backgroundColor: 'rgba(36, 63, 143, 0.04)',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Click the button below to continue the application process to see more options.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ paddingBottom: '40px' }}>
        <Stack
          spacing={3}
          direction="row"
          sx={{
            width: '100%',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            onClick={onAdditionalOptions}
            sx={{
              minWidth: { xs: '225px', sm: 'auto' },
              color: '#FFF',
              textTransform: 'uppercase',
              '&:hover': {
                backgroundColor: '#dbab47',
              },
            }}
          >
            Additional Options
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default BreadMoveForwardModal;